import type { EmailValidationContext } from '@/constants/EmailValidationContext';
import Http from '@/services/http';
import type { IResponseBase } from '@/interfaces';

const http = Http.create();
const API_ENDPOINT = '/validation/email';

export class validationService {
    static async isEmailAvailable(email: string, context: EmailValidationContext, idToIgnore?: string) {
        const response = await http.get<IResponseBase<any>>(API_ENDPOINT, {
            params: { email, context, idToIgnore },
        });
        return response.data;
    }
}